const ARCHIVE_EXTENSIONS = new Set([".zip"]);

const ARCHIVE_MIME_TYPES = new Set([
  "application/zip",
  "application/x-zip-compressed",
]);

export const getFileExtension = (fileName?: string | null): string => {
  const name = (fileName ?? "").trim().toLowerCase();
  const lastDot = name.lastIndexOf(".");
  if (lastDot < 0) {
    return "";
  }

  return name.slice(lastDot);
};

export const isArchiveDocument = (
  fileName?: string | null,
  mimeType?: string | null
): boolean => {
  const extension = getFileExtension(fileName);
  const mime = (mimeType ?? "").toLowerCase().trim();

  return ARCHIVE_EXTENSIONS.has(extension) || ARCHIVE_MIME_TYPES.has(mime);
};
